// removed by extract-text-webpack-plugin
module.exports = {"title-container":"LobTitle__title-container","titleContainer":"LobTitle__title-container","plan-icon":"LobTitle__plan-icon","planIcon":"LobTitle__plan-icon","plan-icon-acc":"LobTitle__plan-icon-acc","planIconAcc":"LobTitle__plan-icon-acc","lob-title":"LobTitle__lob-title","lobTitle":"LobTitle__lob-title","display-flex":"LobTitle__display-flex","displayFlex":"LobTitle__display-flex","title-text":"LobTitle__title-text","titleText":"LobTitle__title-text","link-text":"LobTitle__link-text","linkText":"LobTitle__link-text"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/cart-ui/components/CommonCart/common/LobTitle/LobTitle.scss
// module id = 2371
// module chunks = 8